import {Button, Flex, Tooltip} from "antd";
import React, {CSSProperties, ReactNode, useEffect} from "react";
import {FilesBrowserModal} from "../routes/common/FilesBrowser";
import {useAppSelector} from "../feature/tools";


export interface CoverProps {
    projectId?: string;
    storyId?: string;
    cover?: string;
    alt?: string;
    uploadText?: ReactNode,
    editable?: boolean;
    root?:string,
    style?: CSSProperties
    onFileUploaded?: (cover: string) => void;
    onFileDeleted?: (cover: string) => void;
}

export const Cover = (props: CoverProps) => {
    const [browserVisible, setBrowserVisible] = React.useState(false)
    const creator = useAppSelector(state => state.users.creator)

    return (
        <div style={props.style}>
            <img alt={props.alt} src={props.cover ? props.cover : '/images/placeholder.png'}
                 style={{borderRadius: 8, width: '100%', height: '100%', objectFit: 'cover'}}/>
            {props.editable === true || props.editable === undefined ?
                <Flex justify={'center'} align={'end'}
                      style={{
                          position: 'absolute',
                          width: '100%',
                          height: '100%',
                          top: 0,
                          marginTop: '-10px'
                      }}>

                    <Button style={{background: "#fff"}}
                            onClick={() => setBrowserVisible(true)}
                    >
                        {!props.uploadText ? 'Select Cover' : props.uploadText}
                    </Button>
                </Flex> : ''}
            {
                browserVisible ? <FilesBrowserModal
                    root={(props.root ?? (creator?.id + "/")) + (props.projectId ? (props.projectId + "/") : "") + (props.storyId ? (props.storyId + "/") : "")}
                    onDismiss={() => setBrowserVisible(false)}
                    onSelect={(file) => {
                        if (props.onFileUploaded) {
                            props.onFileUploaded(file)
                        }
                        setBrowserVisible(false)
                    }}
                    types={['images']}
                /> : ''
            }
        </div>
    );
}